module.exports = __webpack_public_path__ + "img/arrow_right_white.f4ba8fac.svg";